module.exports = __webpack_public_path__ + "img/visamaster.35788b0f.jpeg";